export enum ChatFormat {
  None = 'None',
  OpenAI = 'OpenAI',
  Gemini = 'Gemini', // TODO(Zach): Figure out if this corresponds to a really old lib version
  OpenAIImage = 'OpenAIImage',
  Anthropic = 'Anthropic',
  Mistral = 'Mistral',
  OAIResponses = 'OAIResponses',
  OTEL = 'OTEL',
  Langchain = 'Langchain',
  GoogleGenAI = 'GoogleGenAI',
}
